module.exports = __webpack_public_path__ + "img/leads-worker.05041298.png";